import React, { useEffect } from "react";
import Header from "../../../components/Header";
import { client, employee } from "../../../common/svg";
import AdminCointainer from "../../Admin";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../../../service/validation/employee";
import FormTitle from "../../../components/FormTitle";
import Input from "../../../components/FormInputs";
import { ApiService } from "../../../service/api.service";
import { useNavigate, useParams } from "react-router-dom";
import { EmployeeData } from "../../../service/interfaces/ApiResponse.interface";
import { AUTH_URL } from "../../../common/common";
import CustomTabs from "../../../components/Tab";
import { EmployeeFormTabs } from "../../../common/tabs";
import PersonalDetails from "./SubTabs/PersonalDetails";
import DatePicker from "../../../components/Datepicker";
import AddressDetails from "./SubTabs/AddressDetails";
import BankDetails from "./SubTabs/BankDetails";

const ManageEmployee = () => {
  const apiService = new ApiService();
  const { id } = useParams();
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = React.useState<string>("Personal Details");
  const [employeeData, setEmployeeData] = React.useState<any | null>(null);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue, reset, watch,
  } = useForm<EmployeeData>({
    resolver: yupResolver(validationSchema),
    // defaultValues: employeeData ? employeeData: { firstName: "", lastName: "", emailId: "", mobileNumber: "" },
  });
  let entityId = localStorage.getItem("entity_id");

  const getEmployeeData = async () => {
    // Validate employeeId before making API call
    if (!id || id === 'undefined' || id === 'null') {
      console.warn('Invalid employee ID provided:', id);
      return;
    }

    let response: any = await apiService.getApi(`${AUTH_URL}/employee/get-one-route?employeeId=${id}`);
    if (response.status === "200") {
      // let data: EmployeeData = { firstName: "", lastName: "", emailId: "", mobileNumber: "" }
      console.log("Employee Data", response.body);
      if (response.body) {
        setEmployeeData(response.body);
      }
    }
  }
  useEffect(() => {
    if (id) {
      getEmployeeData();
    }
  }, [id]);

  useEffect(() => {
    if (employeeData) {
      reset(employeeData);
    }
  }, [employeeData, reset]);
  const handleCancel = () => {
    reset()
    navigate(-1)
  }
  const onSubmit = async (data: any) => {
    // alert("Submitted");
    // console.log(data);
    data.entityId = entityId;
    if (id) data.employeeId = id;
    const response = id ? await apiService.putApi(`${AUTH_URL}/employee/edit-route`, data) : await apiService.postApi(`${AUTH_URL}/employee/register-route`, data);
    if (response.status === "200") {
      // console.log("Employee Added Successfully", response.data);
      navigate(-1)
    } else {
      console.log("Error in adding employee", response.data);
    }
  };
  return (
    <div>
      <Header
        icon={employee}
        title="Add New Employee"
        showSearch={false}
      ></Header>
      <AdminCointainer>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="bg-white p-4 rounded-[20px] ">
            <FormTitle title="Employee Details" />
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-1">
              <Input
                label="First Name"
                name="employeeDetails.firstName"
                errors={errors}
                register={register}
                placeholder="Enter your first name"
                type="text"
                defaultValue={employeeData?.firstName}
              // value={employeeData?.firstName}
              />
              <Input
                label="Last Name"
                name="employeeDetails.lastName"
                errors={errors}
                register={register}
                placeholder="Enter your last name"
                defaultValue={employeeData?.lastName}
                // value={employeeData?.lastName}
                type="text"
              />
              <Input
                label="Email Id"
                name="employeeDetails.emailId"
                errors={errors}
                register={register}
                // value={employeeData?.emailId}
                defaultValue={employeeData?.emailId}
                placeholder="Enter your first name"
                type="text"
              />
              <Input
                label="Mobile Number"
                name="employeeDetails.mobileNumber"
                errors={errors}
                type="tel"
                maxLength={10}
                register={register}
                // value={employeeData?.mobileNumber}
                defaultValue={employeeData?.mobileNumber}
                placeholder="Enter your mobile number"
              />
              <Input
                label="Aadhar Number"
                name="employeeDetails.aadhaarNumber"
                errors={errors}
                type="tel"
                maxLength={12}
                register={register}
                // value={employeeData?.mobileNumber}
                defaultValue={employeeData?.aadhaarNumber}
                placeholder="Enter your aadhar number"
              />
              <Input
                label="PAN Number"
                name="employeeDetails.panNumber"
                errors={errors}
                type="text"
                maxLength={10}
                uppercase={true}
                register={register}
                // value={employeeData?.mobileNumber}
                defaultValue={employeeData?.panNumber}
                placeholder="Enter your PAN number"
              />

              <DatePicker
                label="Joining Date"
                onDateChange={(date: string) =>
                  setValue("employeeDetails.joiningDate", new Date(date))
                }
                register={register("employeeDetails.joiningDate")}
                name="employeeDetails.joiningDate"
                errors={errors}
                allowPastDates={true}
                includeTime={false}
                disabled={false}
                defaultValue={employeeData?.employeeDetails?.joiningDate}
              />

              <Input
                label="Alternative Phone Number"
                name="employeeDetails.alternativePhoneNumber"
                errors={errors}
                type="tel"
                maxLength={10}
                register={register}
                // value={employeeData?.mobileNumber}
                // defaultValue={employeeData?.}
                placeholder="Enter your alternative phone number"
              />
              <Input
                label="Alternative Email Id"
                name="employeeDetails.alternativeEmailId"
                errors={errors}
                type="text"
                register={register}
                // value={employeeData?.mobileNumber}
                // defaultValue={employeeData?.}
                placeholder="Enter your alternative email id"
              />
              <Input
                label="Relation with Employee"
                name="employeeDetails.relationWithEmployee"
                errors={errors}
                type="text"
                register={register}
                // value={employeeData?.mobileNumber}
                // defaultValue={employeeData?.}
                placeholder="eg. Father, Mother, Spouse"
              />
            </div>

          </div>

          <div className="mt-2">
            <CustomTabs tabs={EmployeeFormTabs} onTabChange={setActiveTab} />
            {
              activeTab === "Personal Details" && <PersonalDetails register={register} errors={errors} setValue={setValue} watch={watch} data={employeeData} />
            }
            {
              activeTab === "Address Details" && <AddressDetails register={register} errors={errors} setValue={setValue} watch={watch} />
            }
            {
              activeTab === "Bank Details" && <BankDetails register={register} errors={errors} setValue={setValue} watch={watch} />
            }
            {/* {
            activeTab === "Documents" && <Documents register={register} errors={errors} setValue={setValue} />
          } */}
            <br />
            <div className="gap-4 flex items-center justify-end mr-8 self-end">
              <button
                type="button"
                className="w-36 h-10 rounded-lg text-[#444FBD] border border-[#444FBD] hover:border-gray-400 transition duration-200"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                type="submit"
                onClick={() => console.log(errors)}
                className={`w-36 h-10 rounded-lg bg-[#444FBD] text-white transition duration-200 ${isSubmitting ? "opacity-50 cursor-not-allowed bg-[gray]" : ""}`}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </form>
      </AdminCointainer>
    </div>
  );
};

export default ManageEmployee;
